// ------------------------------------------------------------------------------
// name: useReactNativeWebView
// author: mudas
// created: 2025/8/6
// ------------------------------------------------------------------------------

import { useCallback } from 'react';
import { useComputed } from 'common/hooks';

export const useReactNativeWebView = () => {
  const isReactNativeWebView = useComputed<boolean>(() => {
    return !!window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function';
  }, [window.ReactNativeWebView]);

  const postMessage = useCallback(
    (type: string, data?: Record<string, any>) => {
      if (isReactNativeWebView) {
        window.ReactNativeWebView?.postMessage(JSON.stringify({ type, ...data }));
      }
    },
    [isReactNativeWebView],
  );

  return { isReactNativeWebView, postMessage };
};
